<template>
  <base-layout>
    <SunpodStationAreasIndex
      :hidePlusButton="$acl.canNotCreate('Sun Pod Areas')"
    />
  </base-layout>
</template>

<script>
import BaseLayout from '@/views/shared/BaseLayout.vue'
import SunpodStationAreasIndex from '@/views/geofence/sunpod-station-area/index.vue'

export default {
  name: 'SunpodStationIndex',
  components: {
    BaseLayout,
    SunpodStationAreasIndex,
  },
}
</script>
